import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const TERMINAL_STATUSES = new Set(["FINISHED", "CANCELED", "COMPLETED"]);

type DispatchOriginsState = {
  // missionId (Mission UUID) → pickedStopId (Stop UUID) at dispatch time.
  byMissionId: Record<string, string>;
};

const initialState: DispatchOriginsState = {
  byMissionId: {},
};

export const Slice = createSlice({
  name: "dispatchOrigins",
  initialState,
  reducers: {
    recordDispatchOrigin: (
      state,
      action: PayloadAction<{ missionId: string; stopId: string }>
    ) => {
      state.byMissionId[action.payload.missionId] = action.payload.stopId;
    },
    clearDispatchOrigin: (state, action: PayloadAction<string>) => {
      delete state.byMissionId[action.payload];
    },
  },
  extraReducers: (builder) => {
    // Clear dispatch origin entries when a mission reaches a terminal status
    // so the map doesn't grow unbounded. We listen to the generic Redux action
    // type string to avoid a circular import with Slices/operatorData.
    builder.addMatcher(
      (
        action
      ): action is PayloadAction<{
        missions?: { id?: string; status?: string };
      }> => action.type === "operatorData/updateMissionOperatorData",
      (state, action) => {
        const mission = action.payload?.missions;
        if (
          mission?.id &&
          mission.status &&
          TERMINAL_STATUSES.has(mission.status)
        ) {
          delete state.byMissionId[mission.id];
        }
      }
    );
  },
});

export default Slice;
